<template>
  <div class="video-panel" :style="{ width, height }">
    <video controls controlslist="nodownload" id="videopanel" v-if="currentVideo.video" class="video1"
      poster="/img/banner/bg_video.jpg" webkit-playsinline="true" style="width: 100%; display: block; height:100%;">
      <source :src="currentVideo.video" type="video/mp4">
    </video>
    <Rightslide v-model="slide" @getClose="slide.show = false" getContainer="body">
      <template slot="content">
        <div class="video-list grayscale">
          <div class="hts">普法视频</div>
          <ul>
            <li v-for="(item, index) in videoList" :key="'key-videolist-' + index" @click="playVideo(item, index)">
              <a href="javascript:;">
                <img :src="item.img[0]" alt>
                <strong class="video-title">{{ item.title }}</strong>
              </a>
            </li>
          </ul>
        </div>
      </template>
      <template slot="footer">
        <div class="btns yel" @click="slide.show = false">
          <button>返回</button>
        </div>
      </template>
    </Rightslide>
    <div class="play-show-btn" @click="slide.show = true">
    </div>

  </div>
</template>
<script>
import Rightslide from '@/components/RightSlide'

export default {
  props: {
    width: {
      type: String,
      default: '8.94rem'
    },
    height: {
      type: String,
      default: '5.7rem'
    }
  },
  components: {
    Rightslide
  },
  data () {
    return {
      currentVideo: '',
      videoList: [],
      slide: {
        show: false
      },
    }
  },
  async mounted () {
    const pointConfig = this.$point.config ? JSON.parse(this.$point.config) : {}
    const result = await this.$api.getPostList({ diagram_id: '5fd17c657edc0146d49338eb', per_page: 500 })
    if (result) {
      this.videoList = result.data.items
    }
    this.currentVideo = this.videoList.length ? Object.assign(this.videoList[0], { index: 0 }) : ''
    this.$nextTick(() => {
      //首页视频区域自动播放代码
      if (pointConfig && pointConfig.isAutoPlay) {
        document.querySelector('#videopanel').autoplay = true
        document.querySelector('#videopanel').play()
        document.querySelector('#waitAudio').src = ''
        document.querySelector('#waitAudio').pause()
      }
      document.querySelector('#videopanel').addEventListener('ended', () => {
        /**
         * 监听到播放结束后
         * 自动切换下一个视频
         * 以下为边界判断
         * 视频列表不能为空，视频只有一条时加上循环播放
         * 视频列表大于1条时，loop整个视频列表
         * currentVideo作为对象进行存储，提供暂停时需要的信息展示
         */
        if (this.videoList.length === 1) {
          document.querySelector('#videopanel').loop = 'loop'
        } else {
          const idx = this.currentVideo.index + 1 === this.videoList.length ? 0 : this.currentVideo.index + 1
          this.currentVideo = Object.assign(this.videoList[idx], { index: idx })
          document.querySelector('#videopanel').src = this.currentVideo.video
          if (point && point.isCycle || this.play === 1) {
            document.querySelector('#videopanel').play()
            const machineId = this.$store.state.device.point.no
            this.$get(`/pufa/post/?post_id=${this.videoList[idx].id}&machine_id=${machineId}&platform=ZD`)
          }
        }
      }, false)
    })
  },
  methods: {
    playVideo (item, index) {
      this.slide.show = false
      this.currentVideo = Object.assign(item, { index })
      const machineId = this.$store.state.device.point.no
      this.$get(`/pufa/post/?post_id=${item.id}&machine_id=${machineId}&platform=ZD`)
      this.$nextTick(() => {
        document.querySelector('#videopanel').src = item.video
        document.querySelector('#videopanel').play()
        document.querySelector('#waitAudio').src = ''
        document.querySelector('#waitAudio').pause()
      })
    },
  }

}
</script>
<style>
video::-internal-media-controls-download-button {
  display: none;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
</style>
<style lang="stylus" scoped>
.play-show-btn
  position fixed
  top 50%
  left 0
  width 0.4rem
  height 1.32rem
  margin-top -0.66rem
  background-color rgba(0, 0, 0, 0.5)
  background-image url('https://qiniu.laway.cn/yn/2023/09/22/21c5fb86592011ee9d54b4055d0b07be.png')
  background-size 0.19rem
  background-position center
  background-repeat no-repeat
  border-radius  0px 0.1rem 0.1rem 0px
.video-list
  padding 0.3rem 0 0 0.3rem
  .hts
    font-size 0.36rem
    font-weight bold
  ul
    display flex
    flex-wrap wrap
    padding 0.3rem 0
    li
      width 50%
      margin-bottom 0.3rem
      a
        display block
        margin-right 0.3rem
        color #333
        img
          width 100%
          min-height 2.1rem
          max-height 2.1rem
          border-radius 0.1rem
          overflow hidden
          object-fit cover
          display block
        strong
          padding-top 0.2rem
          font-size 0.24rem
          display -webkit-box
          -webkit-box-orient vertical
          -webkit-line-clamp 1
          overflow hidden
        p
          padding-top 0.1rem
          font-size 0.18rem
          color #666666
</style>
